export class scan {
  static getCode(obj = {}) {
      let _interval = 60
      let lastInputTime = obj.lastInputTime
      let _t = new Date().getTime()
      let reg = new RegExp(/^\d{1}$/)
      let str = obj.code
      if (reg.test(obj.key) && !lastInputTime) {
          str += obj.key
          lastInputTime = _t
      } else {
          if ((_t - lastInputTime) >= _interval) {
              let _o = this.reset()
              str = _o && _o.str
              lastInputTime = _o && _o.lastInputTime
          } else if (obj.key == 'Enter') {

          } else if (reg.test(obj.key)) {
              str += obj.key
              lastInputTime = _t
          }
      }
      return {
          code: str,
          lastInputTime,
      }
  }
  static reset() {
      let _o = {
          str: '',
          lastInputTime: null
      }
      console.log('清空扫码------------')
      return _o
  }
}